/**
 * Listens for the event that gets triggered when app is running on a different version that the
 * server. It redirects the user to the root route with special query string.
 * The function also listenes for the event triggered when the app boots, and if it detects the
 * query string used on the previous event, it shows a notification saying that there's a new
 * version of the app and that the user needs to login again.
 * @param {ngLocation}   $location  To redirect the user to same URL but without the special query
 *                                  string.
 * @param {ngTimeout}    $timeout   To delay the notification until the app is fully booted.
 * @param {Window}       $window    To redirect the user without the SPA routing (fully refreshing
 *                                  the browser).
 * @param {AppEvents}    appEvents  To listen for the events.
 * @param {AppUtils}     appUtils   To generate a timestamp and use on the query string.
 * @param {UIMessages}   uimessages To show a notification saying that there's a new version of
 *                                  the app.
 * @param {CommonEvents} APP_EVENTS To get the name of the events the function will listen for.
 * @ngesdoc block
 * @ngmodule common
 */
const appOutdated = (
  $location,
  $timeout,
  $window,
  appEvents,
  appUtils,
  uimessages,
  APP_EVENTS,
) => {
  'ngInject';

  // Set the listener for the event triggered when there's a new version of the app.
  appEvents.once(APP_EVENTS.outdated, () => {
    // Generate a timestamp.
    const timestamp = appUtils.timestamp();
    // Redirect the browser to the root route with the special query string.
    $window.location.href = `/?updated=yes&t=${timestamp}`;
  });
  // Set the listener that detects the query string when the app boots.
  appEvents.once(APP_EVENTS.start, () => {
    if ($location.search().updated === 'yes') {
      // If the query string is present...
      $timeout(() => {
        // Show the notification.
        uimessages.notification(
          'A new version has been released. Please login again',
          {
            type: 'info',
            expiration: 10000,
          },
        );
      });
      // Redirect the user to the same route but without the query string.
      $location.url($location.path());
    }
  });
};

export default appOutdated;
